const CLIENT_LOCATION = 'clientLocation';
const CLIENT_LOCATION_EXPIRES_AT = 'clientLocationExpiresAt';

const setClientLocationExpiresAt = () => {
  const durationInDays = 90;
  // eslint-disable-next-line no-magic-numbers
  const expiresAt = Date.now() + durationInDays * 24 * 3600 * 1000;
  try {
    window.localStorage.setItem(CLIENT_LOCATION_EXPIRES_AT, expiresAt.toString());
  } catch {
    // do nothing
  }
};

const parseClientLocation = (clientLocation: string) => clientLocation.split(',').map(Number);

export const getClientLocation = () => {
  let clientLocation;
  let clientLocationExpiresAt;

  try {
    clientLocation = window.localStorage.getItem(CLIENT_LOCATION);
    clientLocationExpiresAt = window.localStorage.getItem(CLIENT_LOCATION_EXPIRES_AT);
  } catch {
    clientLocation = null;
    clientLocationExpiresAt = null;
  }

  if (clientLocation !== null && clientLocationExpiresAt !== null) {
    if (Number(clientLocationExpiresAt) > Date.now()) {
      return parseClientLocation(clientLocation);
    }
    try {
      window.localStorage.removeItem(CLIENT_LOCATION_EXPIRES_AT);
      window.localStorage.removeItem(CLIENT_LOCATION);
    } catch {
      // do nothing
    }
    return null;
  }
  // Basically only for older clients. Should be removed at some point in time.
  // Should not break clients, just give them a slightly worse experience.
  if (clientLocation !== null && clientLocationExpiresAt === null) {
    setClientLocationExpiresAt();
    return parseClientLocation(clientLocation);
  }
  // Probably not necessary, just housekeeping.
  if (clientLocationExpiresAt) {
    try {
      window.localStorage.removeItem(CLIENT_LOCATION_EXPIRES_AT);
    } catch {
      // do nothing
    }
  }
  return null;
};

export const geolocate = async (): Promise<[number, number]> =>
  new Promise((resolve, reject) => {
    window.navigator.geolocation.getCurrentPosition(({ coords: { latitude, longitude } }) => {
      try {
        window.localStorage.setItem(CLIENT_LOCATION, `${latitude},${longitude}`);
      } catch {
        // do nothing
      }
      setClientLocationExpiresAt();
      resolve([longitude, latitude]);
    }, reject);
  });

export const checkSupported = async (grantedCallback: unknown): Promise<boolean> =>
  new Promise((resolve) => {
    if (typeof window.navigator.permissions !== 'undefined') {
      // navigator.permissions has incomplete browser support:
      // See: http://caniuse.com/#feat=permissions-api
      // Test for the case where a browser disables Geolocation because of an
      // insecure origin.
      void window.navigator.permissions.query({ name: 'geolocation' }).then(({ state }) => {
        let clientLocation;
        try {
          clientLocation = window.localStorage.getItem(CLIENT_LOCATION);
        } catch {
          clientLocation = null;
        }
        if (typeof grantedCallback === 'function' && clientLocation) {
          const [latitude, longitude] = clientLocation.split(',').map(Number);
          grantedCallback([longitude, latitude]);
        }
        resolve(state !== 'denied');
      });
    } else {
      resolve(!!window.navigator.geolocation);
    }
  });
